app.factory('icdService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

        function IcdService() {

            this.getFavouriteIcd10List = function(doctorID) {
                return baseService.get(config.API_URL + '/favouritesICD10/byDoctor/' + doctorID).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, FavouriteICD10VO);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getPatientDiagnosisHistory = function(doctorID, patientID) {
                return baseService.get(config.API_URL + '/diagnoses/' + doctorID + '/historyForPatient/' + patientID).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, DiagnosisHistoryWrapper);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getPatientMedicalProcedureHistory = function(doctorID, patientID) {
                return baseService.get(config.API_URL + '/medicalProcedures/' + doctorID + '/historyForPatient/' + patientID).then(
                    function(successResponse) {
                        return objectHelper.translateArray(successResponse, MedicalProcedureVO);
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getFavouriteIcd9List = function(doctorID) {
                return baseService.get(config.API_URL + '/favouritesICD9/byDoctor/' + doctorID).then(
                    function(successResponse) {
                        var favouriteIcd9List = objectHelper.translateArray(successResponse, FavouriteICD9VO);

                        return favouriteIcd9List;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };


            this.addFavouriteIcd10 = function(doctorId, icd10) {
                return baseService.post(config.API_URL + '/favouritesICD10/doctor/' + doctorId + '/add', icd10.id).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.addFavouriteIcd9 = function(doctorId, icd9) {
                return baseService.post(config.API_URL + '/favouritesICD9/doctor/' + doctorId + '/add', icd9.id).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };


            this.deleteFavouriteIcd10 = function(doctorId, icd10) {
                return baseService.post(config.API_URL + '/favouritesICD10/doctor/' + doctorId + '/delete', icd10.id).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteFavouriteIcd9 = function(doctorId, icd9) {
                return baseService.post(config.API_URL + '/favouritesICD9/doctor/' + doctorId + '/delete', icd9.id).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };


        }

        return new IcdService();
    }
]);
